import * as React from "react"

const SvgCloseMini = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8.5 9.375 5.583 12.3a.96.96 0 0 1-.704.275.96.96 0 0 1-.704-.275.95.95 0 0 1-.275-.7.95.95 0 0 1 .275-.7L7.1 7.975 4.175 5.083A.96.96 0 0 1 3.9 4.38q0-.428.275-.704a.95.95 0 0 1 .7-.275.95.95 0 0 1 .7.275L8.5 6.6l2.892-2.925a.96.96 0 0 1 .704-.275q.428 0 .704.275.3.3.3.712 0 .413-.3.688l-2.925 2.9 2.925 2.917q.275.276.275.704c0 .428-.092.52-.275.704q-.3.3-.713.3a.9.9 0 0 1-.687-.3z" />
  </svg>
)
export default SvgCloseMini
